import { LocalizedForm } from "common/localization";

export default class PasswordResetForm extends LocalizedForm {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "password",
                    label: "PASSWORD_RESET.FIELDS.NEW_PASSWORD_LABEL",
                    type: "password",
                    placeholder:
                        "PASSWORD_RESET.FIELDS.NEW_PASSWORD_PLACEHOLDER",
                    rules: [
                        "required",
                        "string",
                        "min:8",
                        "regex:/([^a-zA-Z\\d])+([a-zA-Z\\d])+|([a-zA-Z\\d])+([^a-zA-Z\\d])+/",
                    ],
                },
                {
                    name: "confirmPassword",
                    label: "PASSWORD_RESET.FIELDS.CONFIRM_PASSWORD_LABEL",
                    placeholder:
                        "PASSWORD_RESET.FIELDS.CONFIRM_PASSWORD_PLACEHOLDER",
                    rules: "required|string|same:password",
                    type: "password",
                },
            ],
        };
    }
}
